/**
 * Bulk edit.
 *
 * The same box exports and imports: it opens holding the current data as CSV,
 * so pasting a spreadsheet over it is the import path and copying out of it is
 * the export path, with nothing to keep in sync.
 */

import { Button, TextareaControl, Notice } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import { fromCsv, toCsv } from '../data-operations';

export default function BulkEdit( { attributes, setAttributes } ) {
	const [ open, setOpen ] = useState( false );
	const [ text, setText ] = useState( '' );
	const [ error, setError ] = useState( false );

	const toggle = () => {
		if ( ! open ) {
			setText(
				toCsv(
					attributes.categories || [],
					attributes.series || [],
					attributes.categoryHeading || 'Category'
				)
			);
			setError( false );
		}
		setOpen( ! open );
	};

	const apply = () => {
		const parsed = fromCsv( text, attributes.series || [] );
		if ( ! parsed ) {
			setError( true );
			return;
		}
		setAttributes( parsed );
		setError( false );
		setOpen( false );
	};

	return (
		<div className="brandy-chart-bulk">
			<Button variant="link" size="small" onClick={ toggle }>
				{ open
					? __( 'Close bulk edit', 'brandy-blocks' )
					: __( 'Bulk edit as CSV', 'brandy-blocks' ) }
			</Button>

			{ open && (
				<>
					<TextareaControl
						__nextHasNoMarginBottom
						label={ __( 'CSV', 'brandy-blocks' ) }
						help={ __(
							'First row names the series, first column names the categories. Paste straight from a spreadsheet.',
							'brandy-blocks'
						) }
						rows={ 8 }
						value={ text }
						onChange={ setText }
					/>
					{ error && (
						<Notice status="error" isDismissible={ false }>
							{ __(
								'That needs at least a header row and one data row.',
								'brandy-blocks'
							) }
						</Notice>
					) }
					<Button variant="primary" size="compact" onClick={ apply }>
						{ __( 'Apply', 'brandy-blocks' ) }
					</Button>
				</>
			) }
		</div>
	);
}
